import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

// style overrides for mui datagrid to match out design needs.
// Surface + text colors are routed to theme tokens so the grid follows
// palette.mode: white/original in light, dark surfaces in dark. Semantics of
// the original light appearance are preserved because background.paper is white
// and text.primary/secondary map to the same near-black values in light mode.
export const tableStyleOverrides = (
  theme: Theme
): SystemStyleObject<Theme> => ({
  '&.MuiDataGrid-root': {
    outline: 'none !important',
    border: 'none !important',
    backgroundColor: theme.palette.background.paper,
  },
  '&.MuiDataGrid-root .MuiDataGrid-cell': {
    outline: 'none !important',
    fontStyle: 'normal',
  },
  '&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer': {
    padding: 0,
  },
  '.MuiDataGrid-columnHeaderTitle': {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '0.17px',
    color: theme.palette.text.primary,
  },
  '.MuiTablePagination-root .MuiTablePagination-selectLabel': {
    color: `${theme.palette.text.secondary} !important`,
  },
  '&.MuiDataGrid-root .MuiDataGrid-actionsCell .MuiSvgIcon-root': {
    color: theme.palette.text.primary,
    fontSize: '24px',
  },
  '.MuiDataGrid-overlay': {
    height: 'auto !important',
  },
});

export const tableStyleHideSeparator: SystemStyleObject<Theme> = {
  '& .MuiDataGrid-iconSeparator': {
    display: 'none',
  },
};
